import { render } from "./UcollaborateVersionBanner.vue?vue&type=template&id=ab3f437a&scoped=true"
import script from "./UcollaborateVersionBanner.vue?vue&type=script&lang=js"
export * from "./UcollaborateVersionBanner.vue?vue&type=script&lang=js"

import "./UcollaborateVersionBanner.vue?vue&type=style&index=0&id=ab3f437a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3f437a"]])

export default __exports__